import type { ButtonProps } from './index';
import Button from './index';

import { normalizeSx } from '@/utils/normalizeSx';

import type { Sx } from '@/types/helpers';

const buttonStyles: Sx = {
  width: 250,
  display: 'flex',
  justifyContent: 'flex-start',
  textTransform: 'none',
  backgroundColor: 'rgba(248, 248, 248, 0.20)',
  fontSize: '14px',
  '&:hover': {
    backgroundColor: 'rgba(248, 248, 248, 0.50)'
  },
  '.MuiButton-startIcon': {
    svg: {
      marginRight: 0
    }
  }
};

export const GrayLinkButton = ({ sx, ...props }: ButtonProps) => {
  return (
    <Button
      sx={[buttonStyles, ...normalizeSx(sx)]}
      {...props}
    />
  );
};
